import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthLoadingScreen from '../components/AuthLoadingScreen/AuthLoadingScreen';
import { useAuth } from '../state/AuthContext';
import { getPublicOnlyRedirect } from './routingContract';

export default function PublicOnlyRoute({ children }) {
  const { loading, session } = useAuth();
  const location = useLocation();

  if (loading) return <AuthLoadingScreen />;
  if (session) return <Navigate to={getPublicOnlyRedirect(location.state)} replace />;

  return children;
}
